<template>
  <div class="banner">
    <!-- :style="{ backgroundImage: 'url(../../../assets/Vector.png) ' }" -->
    <img :src="img1" style="display: none" alt="" />
    <div class="container">
      <div class="banner-inner row">
        <!-- Back Button -->
        <button @click="handleBackToSearchClick" class="back-btn">
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.47149 3.80474C8.73184 3.54439 8.73184 3.12228 8.47149 2.86193C8.21114 2.60158 7.78903 2.60158 7.52868 2.86193L2.86201 7.5286C2.60166 7.78895 2.60166 8.21106 2.86201 8.47141L7.52868 13.1381C7.78903 13.3984 8.21114 13.3984 8.47149 13.1381C8.73184 12.8777 8.73184 12.4556 8.47149 12.1953L4.94289 8.66667H12.6667C13.0349 8.66667 13.3334 8.3682 13.3334 8.00001C13.3334 7.63182 13.0349 7.33334 12.6667 7.33334H4.94289L8.47149 3.80474Z"
                fill="#52595E"
              />
            </svg>
          </span>
          Back to search
        </button>
        <!-- Back Button -->
        <!-- User Detail -->
        <div class="user row">
          <div class="user-img">
            <img
              v-if="guide.user && guide.user.imgURL"
              :src="guide.user.imgURL"
              :alt="guide.user.firstname"
            />
          </div>
          <div v-if="guide.user" class="name">
            {{ guide.user.firstname }} {{ guide.user.lastname }}
            <!-- <span>
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12.5" r="12" fill="#557EFB" />
                <path
                  d="M7.44702 7.3382C7.44702 9.47702 10.3072 12.1102 11.9949 13.1837C13.8095 12.0146 16.5203 10.0073 16.5203 7.58087C16.5203 6.42854 15.8482 5 14.4592 5C13.348 5 12.4653 5.48532 11.9949 6.36763C11.502 5.46326 10.2026 5 9.57532 5C8.94803 5 7.44702 5 7.44702 7.3382Z"
                  stroke="white"
                  stroke-width="0.6"
                />
                <path
                  d="M8.79116 16.8675C8.75382 16.669 8.36551 16.0072 8.36551 16.0072L7.08853 14.794C7.08853 14.794 6.41644 14.0882 6.01318 13.6249C5.60993 13.1617 5.57262 12.7426 5.67717 12.4779C5.74069 12.3171 5.96841 12.1911 6.05802 12.1911M6.05802 12.1911C6.17004 12.1691 6.46128 12.2133 6.64047 12.3897C6.84213 12.5882 7.80543 13.5367 8.36551 14.0882C8.92559 14.6396 10.7179 15.3676 11.0315 16.1396C11.3452 16.9116 11.1211 18.7866 11.1211 20.066L8.00706 20.0881C8.10414 19.7351 8.00706 19.0072 8.00706 18.3675C8.00706 17.3766 6.86453 16.5367 6.50609 16.272C6.14764 16.0072 4.62419 14.794 4.62418 14.0882C4.62418 12.7177 4.42081 10.0712 4.53459 9.14707C4.62421 8.41914 4.7138 8.02208 5.11705 8.17649C5.52031 8.3309 5.69954 8.65297 5.69954 9.23531C5.69954 9.81765 5.95347 11.45 6.05802 12.1911Z"
                  stroke="white"
                  stroke-width="0.6"
                />
                <path
                  d="M15.2088 16.8675C15.2462 16.669 15.6345 16.0072 15.6345 16.0072L16.9115 14.794C16.9115 14.794 17.5836 14.0882 17.9868 13.6249C18.3901 13.1617 18.4274 12.7426 18.3228 12.4779C18.2593 12.3171 18.0316 12.1911 17.942 12.1911M17.942 12.1911C17.83 12.1691 17.5387 12.2133 17.3595 12.3897C17.1579 12.5882 16.1946 13.5367 15.6345 14.0882C15.0744 14.6396 13.2821 15.3676 12.9685 16.1396C12.6548 16.9116 12.8789 18.7866 12.8789 20.066L15.9929 20.0881C15.8959 19.7351 15.9929 19.0072 15.9929 18.3675C15.9929 17.3766 17.1355 16.5367 17.4939 16.272C17.8524 16.0072 19.3758 14.794 19.3758 14.0882C19.3758 12.7177 19.5792 10.0712 19.4654 9.14707C19.3758 8.41914 19.2862 8.02208 18.8829 8.17649C18.4797 8.3309 18.3005 8.65297 18.3005 9.23531C18.3005 9.81765 18.0465 11.45 17.942 12.1911Z"
                  stroke="white"
                  stroke-width="0.6"
                />
              </svg>
            </span> -->
          </div>
          <h5 v-if="guide.profile && guide.profile.profileName" class="email">
            @{{ guide.profile.profileName }}
          </h5>
          <div class="rating">
            <span v-for="(svg, i) in ratings" :key="i" v-html="svg">
              {{ svg }}
            </span>
          </div>
          <div v-if="guide.profile && guide.profile.tags" class="fields">
            <div class="field" v-for="(tag, i) in guide.profile.tags" :key="i">
              {{ tag.text }}
            </div>
          </div>
          <p v-if="guide.profile && guide.profile.bio" class="detail">
            <tip-tap-output
              v-if="guide.profile.bio"
              :content="guide.profile.bio"
              :show-less-char="200"
              :use-dots="true"
            />
          </p>
          <!-- <div class="fee">
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.9">
                  <path
                    d="M5.92944 5.11759C5.92945 7.96936 9.74295 11.4802 11.9932 12.9116C14.4128 11.3528 18.0271 8.6764 18.0271 5.44116C18.0271 3.90472 17.131 2 15.279 2C13.7974 2 12.6205 2.64709 11.9932 3.8235C11.3361 2.61768 9.60355 2 8.76717 2C7.93079 2 5.92944 2 5.92944 5.11759Z"
                    stroke="#52595E"
                  />
                  <path
                    d="M7.72155 17.8233C7.67176 17.5586 7.15401 16.6763 7.15401 16.6763L5.45137 15.0587C5.45137 15.0587 4.55525 14.1175 4.01758 13.4999C3.4799 12.8822 3.43016 12.3234 3.56956 11.9705C3.65425 11.7561 3.95788 11.5881 4.07736 11.5881M4.07736 11.5881C4.22672 11.5587 4.61504 11.6176 4.85396 11.8528C5.12284 12.1175 6.40724 13.3822 7.15401 14.1175C7.90078 14.8528 10.2905 15.8233 10.7087 16.8527C11.1269 17.8821 10.8282 20.3821 10.8282 22.0879L6.67608 22.1174C6.80552 21.6468 6.67608 20.6762 6.67608 19.8233C6.67608 18.5021 5.15271 17.3822 4.67478 17.0292C4.19686 16.6763 2.16558 15.0587 2.16558 14.1175C2.16557 12.2902 1.89441 8.76157 2.04612 7.52938C2.16561 6.55881 2.28506 6.02939 2.82274 6.23527C3.36041 6.44115 3.59938 6.87057 3.59938 7.64703C3.59938 8.42349 3.93797 10.6 4.07736 11.5881Z"
                    stroke="#52595E"
                  />
                  <path
                    d="M16.2784 17.8233C16.3282 17.5586 16.846 16.6763 16.846 16.6763L18.5486 15.0587C18.5486 15.0587 19.4447 14.1175 19.9824 13.4999C20.5201 12.8822 20.5698 12.3234 20.4304 11.9705C20.3458 11.7561 20.0421 11.5881 19.9226 11.5881M19.9226 11.5881C19.7733 11.5587 19.385 11.6176 19.146 11.8528C18.8772 12.1175 17.5928 13.3822 16.846 14.1175C16.0992 14.8528 13.7095 15.8233 13.2913 16.8527C12.8731 17.8821 13.1718 20.3821 13.1718 22.0879L17.3239 22.1174C17.1945 21.6468 17.3239 20.6762 17.3239 19.8233C17.3239 18.5021 18.8473 17.3822 19.3252 17.0292C19.8031 16.6763 21.8344 15.0587 21.8344 14.1175C21.8344 12.2902 22.1056 8.76157 21.9539 7.52938C21.8344 6.55881 21.7149 6.02939 21.1773 6.23527C20.6396 6.44115 20.4006 6.87057 20.4006 7.64703C20.4006 8.42349 20.062 10.6 19.9226 11.5881Z"
                    stroke="#52595E"
                  />
                </g>
              </svg>
            </span>
            </span>
            <p>Session Fee is Gifted to Black Lives Matter</p>
          </div> -->
        </div>
        <!-- User Detail -->
        <div class="video">
          <button
            v-if="guide.profile && guide.profile.videoURL"
            class="video-btn btn-light "
          >
            <span>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.0834 6.41666L14.6667 11L21.0834 15.5833V6.41666Z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <!-- stroke="#557EFB" -->
                <path
                  d="M12.8334 4.58333H2.75008C1.73756 4.58333 0.916748 5.40414 0.916748 6.41666V15.5833C0.916748 16.5959 1.73756 17.4167 2.75008 17.4167H12.8334C13.8459 17.4167 14.6667 16.5959 14.6667 15.5833V6.41666C14.6667 5.40414 13.8459 4.58333 12.8334 4.58333Z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <!-- stroke="#557EFB" -->
              </svg>
            </span>
            Video
          </button>
          <!-- <p class="address">Los Angeles, CA</p> -->
          <p
            v-if="
              guide.profile &&
                guide.profile.social &&
                guide.profile.social.businessURL
            "
            class="address"
          >
            <a :href="`https://${guide.profile.social.businessURL}`">{{
              guide.profile.social.businessURL
            }}</a>
          </p>
        </div>
      </div>
    </div>
    <div
      class="top-img"
      v-bind:style="{ 'background-image': 'url(' + img + ')' }"
    ></div>
  </div>
</template>

<script>
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  components: {
    TipTapOutput
  },
  data() {
    return {
      ratings: [
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `
      ],
      img: require("@/assets/top-svg.png"),
      img1: require("@/assets/Vector.png")
    };
  },
  props: {
    guide: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleBackToSearchClick() {
      this.$router.push("/crew");
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  /* bottom center no-repeat  */
  background-image: url("../../../assets/Vector.png") !important;
  background-position: bottom center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  /* border-top: 1px solid #000; */
}
.banner-inner {
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  font-family: "Nunito", sans-serif;
  flex-wrap: wrap;

  padding: 10px 30px;
  position: relative;
  padding-top: 55px;
  /* overflow: hidden; */
  flex-wrap: wrap;
  background-position: bottom center;
  background-size: contain;
  background-repeat: no-repeat;
  padding-bottom: 139px;
}
.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: border-box;
  color: #52595e;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  border: none;
  background: none;
}
.back-btn span {
  padding-right: 10px;
  padding-bottom: 3px;
}
.user {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
}
.user .user-img {
  width: 116px;
  height: 116px;
  img {
    border-radius: 50%;
  }
}
.user .name {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;

  margin: 10px 0;

  color: #52595e;
}
.user .name span {
  padding-bottom: 3px;
}
.email {
  font-style: normal;
  font-weight: normal !important;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #8d99a0;
  font-family: "Nunito", sans-serif;
}
.fields {
  width: 207px;
  height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 24px;
}
.fields .field {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #8d99a0;
  margin-right: 15px;
  cursor: pointer;
}
.detail {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #52595e;
}
.fee {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 4px 0px 0px; */

  /* max-width: 331px; */
  /* width: 100%; */
  height: 32px;

  border-radius: 16px;
}
.fee span {
  /* margin-bottom: 16px; */
}
.fee p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #52595e;
}
.video {
  display: flex;
  /* justify-content: space-between; */
  /* align-items: center; */
}
.video-btn {
  transition: 0.3s linear;
  display: flex;
  align-items: center;
  box-shadow: none;
  justify-content: center;
  padding: 0 !important;
  width: 104px;
  height: 40px;
  border: 1px solid #557efb;
  box-sizing: border-box;
  border-radius: 32px;
  color: #557efb;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  background: none;
  margin-right: 15px;
  path {
    stroke: #557efb;
    transition: 0.3s linear;
  }
}
.video-btn span {
  padding-right: 10px;
}
.video-btn:hover {
  box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
  color: #fff;
  background-color: #557efb;
  path {
    stroke: #fff;
  }
}
/* .video-btn svg path {
  fill: #557efb;
}
.video-btn:hover svg path {
  fill: #fff;
} */
.address {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #52595e;
  width: 122px;
  height: 44px;
  font-family: "Nunito", sans-serif;
}
.top-img {
  position: absolute;
  width: 328px;
  height: 274px;
  background-repeat: no-repeat;
  top: 0px;
  right: 0px;
  z-index: -1;
  /* background-position: bottom center; */
  background-size: contain;
  background-repeat: no-repeat;
}
@media (max-width: 1100px) {
  .banner-inner {
    justify-content: center;
    /* padding-bottom: 10px; */
  }
  .video {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
@media (max-width: 990px) {
  .back-btn {
    position: absolute;
    left: 0;
  }
}
@media (max-width: 500px) {
  .back-btn {
    position: absolute;
    left: 12px;
    top: 17px;
  }
  .banner-inner {
    padding: 10px;
  }
  .user-img {
    width: 80px;
    height: 80px;
  }
  .user {
    margin-top: 50px;
  }
}
@media (max-width: 500px) {
  .video-btn {
    width: 88px;
    height: 32px;
  }
  .fee {
    flex-direction: column;
    margin-bottom: 10px;
  }
  .video {
    flex-direction: column;

    margin-top: 40px;
  }
  .address {
    margin-top: 10px;
    text-align: left;
  }
}
</style>
